import Paragraph from '@tiptap/extension-paragraph';

declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    // Using a separate group key to avoid type conflicts with the existing 'paragraph' commands group.
    // This allows extending functionality while keeping the node name as 'paragraph'.
    customStyledParagraph: {
      setParagraphStyle: (styleKey: string | null) => ReturnType;
    };
  }
}

const CustomStyledParagraph = Paragraph.extend({
  addAttributes() {
    const parentAttributes = this.parent?.() ?? {};
    return {
      ...parentAttributes,
      customStyleKey: {
        default: null,
        parseHTML: (element) => element.getAttribute('data-custom-style') || null,
        renderHTML: (attrs) => (attrs.customStyleKey ? { 'data-custom-style': attrs.customStyleKey } : {}),
      },
    };
  },

  addCommands() {
    const parentCommands = this.parent?.();
    return {
      ...(parentCommands || {}),
      // Keep paragraph command set intact while adding a custom-style toggler.
      setParagraphStyle:
        (styleKey: string | null) =>
        ({ commands }) =>
          commands.updateAttributes(this.name, { customStyleKey: styleKey || null }),
    };
  },
});

export default CustomStyledParagraph;
